import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  discussionLoaded: false,
  leaderboardLoaded: false,
  aggregateLoaded: false,
  joining: false,
  allChallengePackages: [],
  challengePackagesForBuilder: [],
  packagesLoaded: false,
  getDiscussionById: {},
  getAggregateById: {},
  getLeaderboardById: [],
  getChallengeById: {},
  sentChallengeInvites: [],
  allMembersInvited: false,
  refreshJoinedStatusNeeded: false,
  mobileChallenge: {},
  mobileChallengeLoaded: false,
  challengeMilestones: {}
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
